import { InlineError } from "@/modules/form-field/errors";

// NOTE: currently coupled with packages/kreate-server/commands/CreateComment/typing.ts
const MAX_LENGTH = 5000;

export function validateComment(text: string) {
  text = text.trim();
  InlineError.assert$PunishBeforeSubmitting(
    !!text,
    "Comment must not be blank"
  );
  InlineError.assert$PunishWhileEditing(
    text.length <= MAX_LENGTH,
    `Comment too long (${text.length}/${MAX_LENGTH})`
  );
}
